var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1436_4661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.93945 5.18162C1.93945 4.65362 2.12245 4.22162 2.48845 3.88562C2.85445 3.54962 3.32845 3.38162 3.91045 3.38162C4.49245 3.38162 4.96045 3.54962 5.31445 3.88562C5.66845 4.22162 5.84545 4.66562 5.84545 5.21762C5.84545 5.72162 5.67145 6.13562 5.32345 6.45962C4.93945 6.80762 4.45945 6.98162 3.88345 6.98162H3.86545C3.28945 6.98162 2.82445 6.80762 2.47045 6.45962C2.11645 6.11162 1.93945 5.68562 1.93945 5.18162ZM2.13745 18.8076V8.40362H5.61145V18.8076H2.13745ZM7.53745 18.8076H11.0115V12.9936C11.0115 12.6096 11.0535 12.3276 11.1375 12.1476C11.2935 11.7756 11.5155 11.4816 11.8035 11.2656C12.0915 11.0136 12.4635 10.8876 12.9195 10.8876C14.0835 10.8876 14.6655 11.6736 14.6655 13.2456V18.8076H18.1395V12.8316C18.1395 11.2836 17.7765 10.1166 17.0505 9.33062C16.3245 8.54462 15.3615 8.15162 14.1615 8.15162C12.8175 8.15162 11.7675 8.72762 11.0115 9.87962V9.91562H10.9935L11.0115 9.87962V8.40362H7.53745C7.56145 8.83562 7.57345 9.86762 7.57345 11.4996C7.57345 12.3876 7.56745 14.1336 7.55545 16.7376L7.53745 18.8076Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1436_4661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(1 0 0 -1 1.03906 20.4814)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.dd594ff4f35a2e65abf6dc4fe507a8c7.svg";
export { ForwardRef as ReactComponent };